import { Component } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-handler',
  standalone: true,
  imports: [ModalComponent],
  templateUrl: './error-handler.component.html',
  styleUrl: './error-handler.component.css'
})
export class ErrorHandlerComponent {
constructor(private modal: ModalComponent, private router: Router) {}
  handleError(errorCode){
    if (errorCode == 401){
      this.modal.showUnauthModal()
    } else if (errorCode == 403){
      this.modal.showForbiddenModal()
    } else if (errorCode == 404){
      this.router.navigateByUrl("/claim-not-found")
    } else {
      this.router.navigateByUrl("/error")
    }
  }
}
